export default __webpack_public_path__ + "static/report-card-tracker-es-2c6c078a26ffec358511547ff811951b.png";